import { useState, useEffect } from 'react';
import { Box, IconButton, TextField, Typography, Button } from '@mui/material';
import { useUpdatePropertyMutation } from '../../store/docApi';
import { Cancel, Save, Edit } from '@mui/icons-material';

export default function EditableProperty({ item, title, propname, propvalue, placeholder, multiline }) {
  const [updateProperty] = useUpdatePropertyMutation();
  const [value, setValue] = useState(propvalue);
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    setValue(propvalue);
  }, [propvalue]);

  const handleCancel = () => {
    setValue(propvalue);
    setIsEditing(false);
  };

  const handleSave = () => {
    updateProperty({ label: item.label, pk: item.pk, id: item.id, name: propname, value });
    setIsEditing(false);
  };

  const handleBlur = () => {
    if (value === propvalue) {
      setIsEditing(false);
    }
  };

  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
        <b>{title}</b>
        {!isEditing && (
          <IconButton size="small" onClick={() => setIsEditing(true)}>
            <Edit />
          </IconButton>
        )}
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
        {isEditing ? (
          <>
            {multiline ? (
              <TextField
                value={value}
                onChange={(e) => setValue(e.target.value)}
                placeholder={placeholder}
                multiline
                minRows={3}
                onBlur={handleBlur}
                fullWidth
              />
            ) : (
              <TextField value={value} onChange={(e) => setValue(e.target.value)} placeholder={placeholder} onBlur={handleBlur} fullWidth />
            )}
            <Button variant="contained" color="primary" size="small" onClick={handleSave} startIcon={<Save />}>
              Save
            </Button>
            <Button variant="outlined" size="small" onClick={handleCancel} startIcon={<Cancel />}>
              Cancel
            </Button>
          </>
        ) : value ? (
          <Typography sx={{ flexGrow: 1, whiteSpace: 'pre-wrap' }}>{value}</Typography>
        ) : (
          <Typography variant="body2" sx={{ flexGrow: 1, whiteSpace: 'pre-wrap', fontStyle: 'italic' }} color="text.secondary">
            {placeholder}
          </Typography>
        )}
      </Box>
    </Box>
  );
}
